import React, { FC } from 'react';
import { FormControlLabel, Switch } from '@material-ui/core';
import { useTranslation } from 'react-i18next';
import { makeStyles } from '@material-ui/core/styles';

import {
  ClientFollowMappingFragment,
  ClientFollowMappingStatus,
  useUpdateClientFollowMappingMutation,
} from 'api';
import { useNotify } from 'hooks';
import { useUpdateClientFollowMapping } from 'features/admin/updaters';

interface IProps {
  mapping: ClientFollowMappingFragment;
}

const useStyles = makeStyles(theme => ({
  active: {
    color: theme.palette.text.primary,
  },
  inactive: {
    color: theme.palette.text.secondary,
  },
}));

const EnableSwitch: FC<IProps> = ({ mapping }) => {
  const { t } = useTranslation();
  const classes = useStyles();
  const notify = useNotify();

  const mutationOptions = useUpdateClientFollowMapping();
  const { mutate } = useUpdateClientFollowMappingMutation({
    onSuccess: editNotify,
    ...mutationOptions,
  });

  const { Active, Disabled } = ClientFollowMappingStatus;
  const checked = mapping.mapping_status === Active;

  function handleSetStatus(status: ClientFollowMappingStatus) {
    return mutate({
      data: {
        id: mapping.id,
        title: mapping.title,
        mapping_status: status,
        all_users: mapping.all_users,
      },
    });
  }

  function editNotify() {
    const message = t('components:savedSuccessfully');
    notify.info({ message });
  }

  return (
    <FormControlLabel
      label={t('common:status')}
      labelPlacement="start"
      classes={{ label: checked ? classes.active : classes.inactive }}
      control={
        <Switch
          checked={checked}
          onChange={() => handleSetStatus(checked ? Disabled : Active)}
          color="primary"
        />
      }
    />
  );
};

export default EnableSwitch;
